// @flow

import List from './list';
import { default as ListTemplate } from './templates/index.html';

export const COMPONENTS_LIST_NAME = 'list';

export const COMPONENTS_LIST_ENTITIES = [
	{
		name: COMPONENTS_LIST_NAME,
		entity: List,
		template: ListTemplate,
	},
];
